export const LABELS = {
    change: "Change",
    lastChange: "Last changed",
    changedBy: "Changed by",
    old: "Old",
    new: "New",
    yourComment: "Your comment",
    postComment: "Post comment",
    updateComment: "Update comment",
    changeLog: "Change log",
    comments: "Comments",
    placeHolder: "Write here",
    firstComment: "Post your first comment for this case.",
    noComments: "No comments available for this case.",
}